module.exports = __webpack_public_path__ + "img/target-04.286917ee.svg";